import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  styled,
  Typography,
  TextField,
  Link,
  Divider,
  Select,
  InputLabel,
  MenuItem,
  OutlinedInput,
  SelectChangeEvent,
  FormHelperText,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { Style } from "@mui/icons-material";
import { APIEndpointWeb, webapi } from "../../../../client/web";
import {
  FormData,
  IDistrict,
  IProvince,
  ITambon,
} from "./MainFormPersonaNewV1";

const districtsOptions = [
  { label: "ยางตลาด", value: "ยางตลาด" },
  { label: "เมือง", value: "เมือง" },
];
const subdistrictOptions = [
  { label: "หัวนาคำ", value: "หัวนาคำ" },
  { label: "ยางตลาด", value: "ยางตลาด" },
];

interface FormPersonalProps {
  formData: FormData;
  errors: { [key: string]: any };
  allProvince: IProvince[];
  setFormData: any;
  setErrors: any;
}

const FormPersonal: React.FC<FormPersonalProps> = ({
  formData,
  setFormData,
  errors,
  setErrors,
  allProvince,
}) => {
  const [loadingDistricts, setLoadingDistricts] = useState<boolean>(false);
  const [loadingTambon, setLoadingTambon] = useState<boolean>(false);
  const [allDistricts, setAllDistricts] = useState<IDistrict[]>([]);
  const [allTambon, setAllTambon] = useState<ITambon[]>([]);

  useEffect(() => {
    if (
      Array.isArray(allProvince) &&
      allProvince.length > 0 &&
      formData &&
      formData?.current_address?.province
    ) {
      // const filtered = allDistricts.filter((d) => d.province_code === selectedProvince.province_code);
      // setFilteredDistricts(filtered);
      // console.log("formData?.current_address?.province", formData.current_address.province)
      // if (dataProvince) {
      const xml = allProvince.find(
        (p: IProvince) =>
          p.province_thai_name === formData.current_address.province
      );
      if (xml) {
        getDataAllDistrict(xml, formData);
      } else {
        setFormData((prev: any) => ({
          ...prev,
          current_address: {
            ...prev.current_address,
            province: "",
            district: "",
            sub_district: "",
            zip_code: "",
          },
        }));
        // }
      }
    }
  }, [allProvince]);

  const validateMobile = (business_full_cid_1: string) => {
    return /^[0-9]{10}$/.test(business_full_cid_1);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  // const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = e.target;

  //   setFormData((prev: { current_address: any; }) => ({
  //     ...prev,
  //     current_address: {
  //       ...prev.current_address,
  //       [name]: value, // อัปเดตฟิลด์ที่เปลี่ยนแปลงใน current_address
  //     },
  //   }));
  //   // }

  //   // อัปเดต errors
  //   // setErrors((prevErrors: any) => {
  //   //   const newErrors = { ...prevErrors };

  //   //   // Check if the value has content
  //   //   if (value.trim()) {
  //   //     // If it has content, remove the error for this field
  //   //     delete newErrors[name];
  //   //   } else {
  //   //     // If it's empty, set the error for this field
  //   //     newErrors[name] = true;
  //   //   }

  //   //   // Return the updated errors object
  //   //   return newErrors;
  //   // });

  //   if (name === "mobile_number") {
  //     setErrors((prevErrors: any) => {
  //       const newErrors = { ...prevErrors };

  //       if (!validateMobile(value)) {
  //         newErrors[name] = true; // Set error only for the field being updated
  //       } else {
  //         delete newErrors[name]; // Remove error if valid
  //       }

  //       return newErrors;
  //     });
  //   }else{
  //     setErrors((prevErrors: any) => {
  //       const newErrors = { ...prevErrors };
  //       // ตรวจสอบว่า value ของฟิลด์นี้มีค่าหรือไม่
  //       if (value.trim()) {
  //           delete newErrors[name]; // ถ้ามีค่าให้ลบข้อผิดพลาด
  //       } else {
  //           newErrors[name] = true;
  //       }
  //       return newErrors;
  //   });
  //   }

  // };

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev: { current_address: any }) => ({
      ...prev,
      current_address: {
        ...prev.current_address,
        [name]: value, // Ensure 'name' corresponds to the correct field
      },
    }));

    setErrors((prevErrors: any) => {
      const newErrors = { ...prevErrors };

      // ✅ ตรวจสอบให้แน่ใจว่า current_address มีอยู่
      if (!newErrors.current_address) {
        newErrors.current_address = {};
      }
      console.log("newErrors :>> ", newErrors);
      // ✅ แยก key ออกมาในกรณีเป็น "current_address.email"
      const fieldName = name.startsWith("current_address.")
        ? name.split(".")[1]
        : name;
      console.log("fieldName :>> ", fieldName);
      // ✅ ตรวจสอบ address
      if (fieldName === "address") {
        if (value.trim()) {
          delete newErrors.current_address.address;
        } else {
          newErrors.current_address.address = "กรุณากรอกสถานที่ตั้งหน่วยบริการ";
        }
      }
      // ✅ ตรวจสอบ email
      else if (fieldName === "email") {
        if (!validateEmail(value)) {
          newErrors.current_address.email = "อีเมลไม่ถูกต้อง";
        } else {
          delete newErrors.current_address.email;
        }
      } else if (fieldName === "mobile_number") {
        if (!validateMobile(value)) {
          newErrors.current_address.mobile_number =
            "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง";
        } else {
          delete newErrors.current_address.mobile_number;
        }
      }
      // ✅ สำหรับฟิลด์อื่น ๆ ให้กำหนดเป็น true
      else {
        if (value.trim()) {
          delete newErrors.current_address[fieldName]; // ถ้ากรอกข้อมูลแล้วให้ลบ error
        } else {
          newErrors.current_address[fieldName] = "กรุณากรอกข้อมูล"; // ถ้าค่าว่างให้แสดง error
        }
      }

      return newErrors;
    });

    // setErrors((prevErrors: any) => {
    //   const newErrors = { ...prevErrors };

    //   // Check if the field is inside current_address
    //   if (name === "address") {
    //     if (value.trim()) {
    //       delete newErrors["current_address.address"];
    //     } else {
    //       newErrors["current_address.address"] = true;
    //     }
    //   } else if (name === "mobile_number") {
    //     if (!validateMobile(value)) {
    //       newErrors[name] = true;
    //     } else {
    //       delete newErrors[name];
    //     }
    //   } else {
    //     if (value.trim()) {
    //       delete newErrors[name];
    //     } else {
    //       newErrors[name] = true;
    //     }
    //   }
    //   return newErrors;
    // });
  };

  const getDataAllDistrict = async (
    value: IProvince | null,
    dataProvince: any | null = null
  ) => {
    // console.log('value sdss:>> ', value?.province_code);
    try {
      setLoadingDistricts(true);
      setLoadingTambon(true);
      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllDistrict}${value?.province_code}`
      );
      // console.log("data.result", data.result)
      if (Array.isArray(data.result)) {
        setAllDistricts(data.result);
        if (value && dataProvince) {
          // โคกโพธิ์ไชย dataProvince.current_address.province
          const xml = data.result.find(
            (p: any) =>
              p.district_thai_name === dataProvince.current_address.district
          );
          // console.log("xmlxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", ต้องลบ)
          if (xml) {
            let dataCode: IDistrict = {
              province_code: xml.province_code,
              district_english_name: xml.district_english_name,
              district_thai_name: xml.district_thai_name,
              district_code: xml.district_code,
            };
            await getDataGetAllTambon(dataCode, dataProvince);
          } else {
            setFormData((prev: any) => ({
              ...prev,
              current_address: {
                ...prev.current_address,
                district: "",
                sub_district: "",
                zip_code: "",
              },
            }));
          }
        }
      } else {
        setAllDistricts([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDistricts(false);
      setLoadingTambon(false);
    }
  };

  const getDataGetAllTambon = async (
    selectedOption: IDistrict | null,
    dataProvince: any | null = null
  ) => {
    // console.log("selectedOption", selectedOption)
    try {
      setLoadingTambon(true);
      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllTambon}${selectedOption?.district_code}&province_code=${selectedOption?.province_code}`
      );
      // console.log('getDataGetAllTambon :>> ', data.result);
      // console.log('dataProvinceSubbbbbbbbbbbb :>> ', dataProvince?.sub_district);
      if (Array.isArray(data.result)) {
        setAllTambon(data.result);
        /////////////////////////////////////////////// ทำครั้งแรก
        // console.log("dataProvince", dataProvince)
        // console.log("selectedOption", selectedOption)
        if (dataProvince) {
          const xml = data.result.find(
            (p: any) =>
              p.tambon_thai_name === dataProvince.current_address.sub_district
          );
          if (xml) {
            let formDatamock = formData;
            formDatamock.current_address.zip_code = xml.zip_code;
            setFormData((prev: any) => ({
              ...prev,
              current_address: {
                ...prev.current_address,
                zip_code: xml.zip_code,
              },
            }));
          } else {
            setFormData((prev: any) => ({
              ...prev,
              current_address: {
                ...prev.current_address,
                sub_district: "",
                zip_code: "",
              },
            }));
          }
        }
      } else {
        setAllTambon([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingTambon(false);
    }
  };

  const handleProvinceChange = (_: any, selectedOption: IProvince | null) => {
    if (selectedOption) {
      setFormData((prev: any) => ({
        ...prev,
        current_address: {
          ...prev.current_address,
          province: selectedOption.province_thai_name,
          district: "",
          sub_district: "",
          zip_code: "",
        },
      }));
      setErrors((prev: any) => ({
        ...prev,
        current_address: { ...prev.current_address, province: false },
      }));
      getDataAllDistrict(selectedOption);
    }
  };

  const handleDistrictChange = (_: any, selectedOption: IDistrict | null) => {
    if (selectedOption) {
      setFormData((prev: any) => ({
        ...prev,
        current_address: {
          ...prev.current_address,
          district: selectedOption.district_thai_name,
          sub_district: "",
          zip_code: "",
        },
      }));
      setErrors((prev: any) => ({
        ...prev,
        current_address: { ...prev.current_address, district: false },
      }));
      getDataGetAllTambon(selectedOption);
    }
  };

  const handleTambonChange = (_: any, selectedOption: ITambon | null) => {
    if (selectedOption) {
      setFormData((prev: any) => ({
        ...prev,
        current_address: {
          ...prev.current_address,
          sub_district: selectedOption.tambon_thai_name,
          zip_code: selectedOption.zip_code,
        },
      }));
      setErrors((prev: any) => ({
        ...prev,
        current_address: {
          ...prev.current_address,
          sub_district: false,
          zip_code: false,
        },
      }));
    }
  };

  return (
    <>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <form>
        <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
          <Grid item xs={12} md={2} sx={{ alignSelf: "flex-start" }}>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              ที่อยู่ที่สามารถติดต่อได้
            </Typography>
          </Grid>
          <Grid item xs={12} md={10}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <FormControl sx={{ minWidth: "100%" }}>
                  <TextField
                    variant="outlined"
                    sx={{ backgroundColor: "#ffffff" }}
                    label={
                      <span>
                        ที่อยู่ <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="outlined-basic"
                    placeholder="กรุณากรอกที่อยู่"
                    value={formData.current_address.address || ""}
                    name="address"
                    // onChange={handleFormChange}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก
                    
                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>); // แปลงเป็นประเภทที่ถูกต้อง
                      }
                    }}
                    
                    error={!!errors.current_address?.address} // Check for error in nested object
                    helperText={
                      errors.current_address?.address
                        ? "กรุณากรอกชื่อหน่วยบริการ"
                        : ""
                    } // Custom error message
                    // error={!!errors["current_address.address"]}
                    // helperText={errors["current_address.address"] ? "กรุณากรอกที่อยู่" : ""}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl sx={{ minWidth: "100%" }}>
                  <TextField
                    variant="outlined"
                    sx={{ backgroundColor: "#ffffff" }}
                    label={
                      <span>
                        หมู่ / อาคาร <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="outlined-basic"
                    placeholder="กรุณากรอกหมู่/อาคาร"
                    value={formData.current_address.moo}
                    name="moo"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก
                    
                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>); // แปลงเป็นประเภทที่ถูกต้อง
                      }
                    }}
                    error={!!errors.current_address?.moo} // Check for error in nested object
                    helperText={
                      errors.current_address?.moo ? "กรุณากรอกหมู่/อาคาร" : ""
                    } // Custom error message
                    // error={!!errors["current_address.moo"]}
                    // helperText={errors["current_address.moo"] ? "กรุณากรอกที่อยู่" : ""}
                  />
                </FormControl>
              </Grid>

              {/* <Grid item xs={12} md={3}>
                    <FormControl sx={{ minWidth: "100%" }}>
                      <TextField
                        variant="outlined"
                        sx={{ minWidth: "100%" }}
                        label={
                          <span>
                            เลขที่ <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        id="outlined-basic"
                        placeholder="กรุณากรอกเลขที่"
                        value={formData.no}
                        name="no"
                        onChange={handleFormChange}
                        error={errors.no}
                        helperText={errors.no ? "กรุณากรอกเลขที่" : ""}
                      />
                    </FormControl>
                  </Grid> */}
              <Grid item xs={12} md={6}>
                <FormControl sx={{ minWidth: "100%" }}>
                  <TextField
                    variant="outlined"
                    sx={{ minWidth: "100%", backgroundColor: "#ffffff" }}
                    label={
                      <span>
                        ตรอก / ซอย <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="outlined-basic"
                    placeholder="กรุณากรอกตรอก / ซอย"
                    value={formData.current_address.soi}
                    name="soi"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก
                    
                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>); // แปลงเป็นประเภทที่ถูกต้อง
                      }
                    }}
                    error={!!errors.current_address?.soi} // Check for error in nested object
                    helperText={
                      errors.current_address?.soi ? "กรุณากรอกตรอก / ซอย" : ""
                    } // Custom error message
                    // error={!!errors["current_address.soi"]}
                    // helperText={errors["current_address.soi"] ? "กรุณากรอกที่อยู่" : ""}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl sx={{ minWidth: "100%" }}>
                  <TextField
                    variant="outlined"
                    sx={{ minWidth: "100%", backgroundColor: "#ffffff" }}
                    label={
                      <span>
                        ถนน <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="outlined-size-small"
                    placeholder="กรุณากรอกถนน"
                    value={formData.current_address.street}
                    name="street"
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const regex = /^[^\s]+(\s[^\s]*)?$/; // ตรวจสอบไม่ให้มีช่องว่างหลังคำแรก
                    
                      // ถ้าข้อความตรงกับ regex ก็ให้ทำการอัพเดตค่า
                      if (regex.test(inputValue) || inputValue === "") {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>); // แปลงเป็นประเภทที่ถูกต้อง
                      }
                    }}
                    error={!!errors.current_address?.street} // Check for error in nested object
                    helperText={
                      errors.current_address?.street ? "กรุณากรอกถนน" : ""
                    } // Custom error message
                    // error={!!errors["current_address.street"]}
                    // helperText={errors["current_address.street"] ? "กรุณากรอกที่อยู่" : ""}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  sx={{ minWidth: "100%" }}
                  size="small"
                  // error={Boolean(errors.province)}
                >
                  {/* <Autocomplete
                              id="province-select"
                              options={allProvince}
                              getOptionLabel={(option) => option.province_thai_name || ""}
                              isOptionEqualToValue={(option, value) => option.province_code === value.province_code}
                              value={allProvince.find((option) => option.province_thai_name === formData.current_address.province) || null}
                              // onChange={(event, value: any) => handleProvinceChange(event, value)}
                              renderInput={(params) => (
                                <TextField
                                      {...params}
                                      label={
                                    <span>
                                            จังหวัด <span style={{ color: "red" }}>*</span>
                                    </span>
                                              }
                                      name="province"
                                        variant="outlined"
                                        fullWidth
                                        error={Boolean(errors.province)}
                                        helperText={
                                                errors.province ? "กรุณาเลือกจังหวัด" : null
                                        }
                                            />
                                          )}
                                        /> */}
                  {/* {formData.current_address.province} */}
                  <Autocomplete
                    id="province-select"
                    clearIcon={false}
                    options={allProvince}
                    value={
                      allProvince.find(
                        (option) =>
                          option.province_thai_name ===
                          formData.current_address.province
                      ) || null
                    }
                    getOptionLabel={(option) => option.province_thai_name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.province_code === value.province_code
                    }
                    onChange={(_, value) => {
                      if (value) {
                        handleProvinceChange("", value);
                        // handleFormChange({
                        //   target: {
                        //     name: "province",
                        //     value: value.province_thai_name,
                        //   },
                        // } as React.ChangeEvent<HTMLInputElement>);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            จังหวัด <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="province"
                        variant="outlined"
                        fullWidth
                        sx={{
                          backgroundColor: "#ffffff",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "4px",
                            backgroundColor: "#ffffff",
                          },
                        }}
                        error={!!errors.current_address?.province} // Check for error in nested object
                        helperText={
                          errors.current_address?.province
                            ? "กรุณาเลือกจังหวัด"
                            : ""
                        } // Custom error message
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  sx={{ minWidth: "100%" }}
                  size="small"
                  error={Boolean(errors.district)}
                >
                  {/* 
                            <Autocomplete
                                          id="district-select"
                  
                                          options={allDistricts}
                                          getOptionLabel={(option) => option.district_thai_name}
                                          value={allDistricts.find((option) => option.district_thai_name === formData.district) || null
                                          }
                                          onChange={handleDistrictChange}
                  
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={
                                                <span>
                                                  อำเภอ <span style={{ color: "red" }}>*</span>
                                                </span>
                                              }
                                              name="district"
                                              variant="outlined"
                                              fullWidth
                                              error={Boolean(errors.district)}
                                              helperText={
                                                errors.district ? "กรุณาเลือกอำเภอ / เขต" : null
                                              }
                                            />
                                          )}
                                        /> */}
                  <Autocomplete
                    id="district-select"
                    clearIcon={false}
                    disabled={
                      !formData.current_address.province || loadingDistricts
                    }
                    options={allDistricts}
                    getOptionLabel={(option) => option.district_thai_name}
                    value={
                      allDistricts.find(
                        (option) =>
                          option.district_thai_name ===
                          formData.current_address.district
                      ) || null
                    }
                    onChange={(_, value) => {
                      if (value) {
                        handleDistrictChange("", value);
                        // handleFormChange({
                        //   target: {
                        //     name: "district",
                        //     value: value.district_thai_name,
                        //   },
                        // } as React.ChangeEvent<HTMLInputElement>);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            อำเภอ <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="district"
                        variant="outlined"
                        fullWidth
                        sx={{
                          backgroundColor: "#ffffff",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "4px",
                            backgroundColor: "#ffffff",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingDistricts ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                        // error={errors.district}
                        // helperText={
                        //   errors.district ? "กรุณาเลือกอำเภอ" : ""
                        // }

                        error={!!errors.current_address?.district}
                        helperText={
                          errors.current_address?.district
                            ? "กรุณาเลือกอำเภอ"
                            : ""
                        } // Custom error message
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  sx={{ minWidth: "100%" }}
                  size="small"
                  // error={Boolean(errors.sub_district)}
                  error={Boolean(errors.current_address?.sub_district)}
                >
                  {/* <Autocomplete
                                          id="subdistrict-select"
                                          options={allTambon ?? []} // ป้องกัน options เป็น null หรือ undefined
                                          value={allTambon && Array.isArray(allTambon)
                                            ? allTambon.find((option) => option.tambon_thai_name === formData.sub_district) || null
                                            : null
                                          }
                                          getOptionLabel={(option) => option.tambon_thai_name}
                                          onChange={(event, value: ITambon | null) => handleTambonChange(event, value)}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={
                                                <span>
                                                  ตำบล / แขวง{" "}
                                                  <span style={{ color: "red" }}>*</span>
                                                </span>
                                              }
                                              name="sub_district"
                                              variant="outlined"
                                              fullWidth
                                              error={Boolean(errors.sub_district)}
                                              helperText={
                                                errors.sub_district
                                                  ? "กรุณากรอกเลือกตำบล / แขวง"
                                                  : null
                                              }
                                            />
                                          )}
                        /> */}
                  <Autocomplete
                    id="subdistrict-select"
                    clearIcon={false}
                    disabled={
                      !formData.current_address.district || loadingTambon
                    }
                    options={allTambon ?? []} // ป้องกัน options เป็น null หรือ undefined
                    value={
                      allTambon && Array.isArray(allTambon)
                        ? allTambon.find(
                            (option) =>
                              option.tambon_thai_name ===
                              formData.current_address.sub_district
                          ) || null
                        : null
                    }
                    getOptionLabel={(option) => option.tambon_thai_name}
                    onChange={(_, value) => {
                      if (value) {
                        handleTambonChange("", value);
                        // handleFormChange({
                        //   target: {
                        //     name: "sub_district",
                        //     value: value.tambon_thai_name,
                        //   },
                        // } as React.ChangeEvent<HTMLInputElement>);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            ตำบล / แขวง <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="sub_district"
                        variant="outlined"
                        fullWidth
                        sx={{
                          backgroundColor: "#ffffff",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "4px",
                            backgroundColor: "#ffffff",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingTambon ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                        // error={errors.sub_district}
                        // helperText={
                        //   errors.sub_district ? "กรุณาเลือกตำบล / แขวง" : ""
                        // }
                        error={!!errors.current_address?.sub_district} // Check for error in nested object
                        helperText={
                          errors.current_address?.sub_district
                            ? "กรุณาเลือกตำบล / แขวง"
                            : ""
                        } // Custom error message
                        // error={!!errors["current_address.street"]}
                        // helperText={errors["current_address.street"] ? "กรุณาเลือกตำบล / แขวง" : ""}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  disabled={
                    loadingTambon || !formData?.current_address?.sub_district
                  }
                  name="zip_code"
                  label={
                    <span>
                      รหัสไปรษณีย์ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  value={formData.current_address.zip_code}
                  // onChange={handleFormChange}
                  fullWidth
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 5);
                  }}
                  inputProps={{
                    maxLength: 5,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                  error={
                    !!errors.current_address?.zip_code ||
                    (formData.current_address.zip_code.length > 0 &&
                      formData.current_address.zip_code.length < 5)
                  }
                  helperText={
                    errors.current_address?.zip_code ||
                    (formData.current_address.zip_code.length > 0 &&
                    formData.current_address.zip_code.length < 5
                      ? "กรุณากรอกรหัสไปรษณีย์ให้ครบ 5 หลัก"
                      : "")
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl sx={{ minWidth: "100%" }}>
                  <TextField
                    variant="outlined"
                    sx={{ backgroundColor: "#ffffff" }}
                    label={
                      <span>
                        ไปรษณีย์อิเล็กทรอนิกส์{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    placeholder="กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์"
                    value={formData.current_address.email}
                    name="email"
                    // onChange={handleFormChange}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const regex = /^[^\s]*$/;  // regex ตรวจสอบว่าไม่มีช่องว่าง (space)
                    
                      // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                      if (regex.test(inputValue)) {
                        handleFormChange(e as React.ChangeEvent<HTMLInputElement>);
                      }
                    }}
                    error={!!errors.current_address?.email} // Check for error in nested object
                    helperText={
                      errors.current_address?.email
                        ? "กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์"
                        : ""
                    } // Custom error message
                    // error={errors.email}
                    // helperText={
                    //   errors.email ? "กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์" : ""
                    // }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl sx={{ minWidth: "100%" }}>
                  <TextField
                    variant="outlined"
                    sx={{ backgroundColor: "#ffffff" }}
                    label={
                      <span>
                        หมายเลขโทรศัพท์มือถือ{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    placeholder="กรุณากรอกหมายเลขโทรศัพท์มือถือ"
                    value={formData.current_address.mobile_number}
                    name="mobile_number"
                    onChange={handleFormChange}
                    error={!!errors.current_address?.mobile_number} // Check for error in nested object
                    helperText={
                      errors.current_address?.mobile_number
                        ? "กรุณากรอกหมายเลขโทรศัพท์มือถือ"
                        : ""
                    } // Custom error message
                    inputProps={{
                      maxLength: 10,
                      pattern: "[0-9]*",
                      inputMode: "numeric",
                    }}
                    // error={!!errors["current_address.mobile_number"]}
                    // helperText={errors["current_address.mobile_number"] ? "กรุณากรอกที่อยู่" : ""}
                  />
                </FormControl>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                {/* <Button
              type="submit"
              endIcon={<ArrowForwardIosIcon />}
              variant="contained"
              color="primary"
              sx={{ mt: 2, borderRadius: 5 }}
            >
              ดำเนินการต่อ
            </Button> */}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default FormPersonal;
